import { render, staticRenderFns } from "./JudgmentTopic.vue?vue&type=template&id=8a770c16&scoped=true&"
import script from "./JudgmentTopic.vue?vue&type=script&lang=js&"
export * from "./JudgmentTopic.vue?vue&type=script&lang=js&"
import style0 from "./JudgmentTopic.vue?vue&type=style&index=0&id=8a770c16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a770c16",
  null
  
)

export default component.exports